// Central place for the handful of things that are genuinely per-event
// infrastructure (a storage bucket that must exist ahead of time). Add a
// new event's bucket here once it's actually been created in Supabase —
// until then, getDocsBucket() returns null and callers show a friendly
// "not ready yet" message instead of hitting a bucket that doesn't exist.
const DOCS_BUCKET_BY_EVENT = {
  "66489b2f-1fa8-4307-a57d-d62a60dba217": "Global_Village_Vendors_2026",
  "c6d6af46-e3ac-43fe-b5ec-319c9988fb61": "Global_Village_Vendors_2026",
};

export function getDocsBucket(eventKey) {
  return DOCS_BUCKET_BY_EVENT[eventKey] || null;
}

// Product photos live in one shared "product_photos" bucket that already
// exists for every event — only the FOLDER inside it varies. Folders don't
// need to be pre-created (Supabase Storage creates them implicitly on
// first upload), so this is safe to default to the event key itself with
// no registry entry required for new events.
const PRODUCT_PHOTOS_PREFIX_BY_EVENT = {
  "66489b2f-1fa8-4307-a57d-d62a60dba217": "summer_2026",
};

export function getProductPhotosPrefix(eventKey) {
  return PRODUCT_PHOTOS_PREFIX_BY_EVENT[eventKey] || eventKey;
}